// extracted by mini-css-extract-plugin
export var listItemDisc = "article-module--listItemDisc--773Tb";
export var paragraphspacing = "article-module--paragraphspacing--B830L";